<template>
  <div class="queryDetails">
    <!-- 简易订餐 -->
    <van-nav-bar
      :title="name || '订餐'"
      left-text
      left-arrow
      @click-left="onClickLeft"
      :right-text="CloundEntid == '139' ? '菜单' : ''"
      @click-right="onClickRight"
    />
    <div class="overflow_div">
      <!-- 查询条件--日期 -->
      <div class="date_content">
        <div class="year_box">
          <div class="icon_box" @click="arrowsYear('left')">
            <van-icon name="arrow-left" />
          </div>
          <div
            class="year_btn"
            v-for="(it, idx) in years"
            :key="idx"
            :class="[
              1 == 1 ? 'cao' + idx : '',
              checkedYear == it ? 'checkd_year' : ''
            ]"
            @click="getOneYear(it)"
          >
            <div class="year">{{ it + '年' }}</div>
          </div>
          <div class="icon_box" @click="arrowsYear('right')">
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="month_box">
          <div class="month_btn" v-for="(it, idx) in months" :key="idx">
            <div
              class="month"
              :class="checkedMonth == it ? 'checkd_Month' : ''"
              @click="getOneMonth(it)"
            >
              {{ it + '月' }}
            </div>
          </div>
        </div>
        <div class="table_content" :style="tabStyle">
          <div class="auto_table">
            <table ref="table" class="table">
              <!-- 表头 -->
              <tr class="top">
                <th
                  v-for="(item_th, index_th) in thList"
                  :key="index_th"
                  v-show="(item_th.chnname || index_th == 0) && item_th.show"
                  :class="{ brdr: item_th.fieldname.indexOf('bflag') > -1 }"
                >
                  <div class="title">
                    <template
                      v-if="
                        index_th > 0 && index_th < 13 && !simple_book_need_ft
                      "
                    >
                      <img
                        :src="
                          require('@assets/img/p0' +
                            ((((index_th - 1) / 2) | 0) + 1) +
                            '.png')
                        "
                        alt=""
                      />
                    </template>
                    {{ item_th.chnname }}
                  </div>
                </th>
              </tr>
              <!--展示列表数据 class="cont"-->
              <tr
                :class="{ cont: true }"
                v-for="(item_tr, index_tr) in bookinfo"
                :key="index_tr"
              >
                <td
                  v-for="(item_td, index_td) in thList"
                  :key="index_td"
                  :class="{
                    disabled:
                      (!item_tr[
                        'can_book' + ((((index_td - 1) / 2) | 0) + 1)
                      ] &&
                        item_td.fieldname != 'yymmdd2') ||
                      (item_td.fieldname == 'yymmdd2' &&
                        !item_tr.can_book1 &&
                        !item_tr.can_book2 &&
                        !item_tr.can_book3 &&
                        !item_tr.can_book4 &&
                        !item_tr.can_book5 &&
                        !item_tr.can_book6),
                    hol: item_tr.restid,
                    brdr: item_td.fieldname.indexOf('bflag') > -1
                  }"
                  :style="[
                    { color: item_tr.fontcolor ? item_tr.fontcolor : '' },
                    { backgroundColor: item_tr.bgcolor ? item_tr.bgcolor : '' }
                  ]"
                  v-show="(item_td.chnname || index_td == 0) && item_td.show"
                >
                  <div class="comm_box">
                    <div
                      class="boolean_box fs24"
                      v-if="item_td.fieldname.indexOf('bflag') > -1"
                      @click="
                        item_tr[
                          'can_book' + ((((index_td - 1) / 2) | 0) + 1)
                        ] && showCantennList(item_tr, item_td.fieldname)
                      "
                    >
                      {{ item_tr[item_td.fieldname] }}
                      <van-icon
                        name="arrow-down"
                        v-show="
                          item_tr['can_book' + ((((index_td - 1) / 2) | 0) + 1)]
                        "
                      />
                    </div>
                    <div
                      class="boolean_box"
                      v-else-if="item_td.fieldname != 'yymmdd2'"
                    >
                      <van-checkbox
                        v-model="item_tr[item_td.fieldname]"
                        :disabled="
                          !item_tr[
                            'can_book' + ((((index_td - 1) / 2) | 0) + 1)
                          ]
                        "
                        :class="{
                          hasbook: initbookinfo[index_tr][item_td.fieldname]
                        }"
                      ></van-checkbox>
                      <!-- {{initbookinfo[index_tr][item_td.fieldname]}} -->
                    </div>
                    <div :class="{ text_box: true }" v-else>
                      {{ item_tr[item_td.fieldname] }}
                    </div>
                  </div>
                </td>
              </tr>
              <!-- 最后一行的合计数据 需要高亮 -->
              <tr class="cont sum">
                <td
                  v-for="(item_th, index_th) in thList"
                  :key="index_th"
                  v-show="(item_th.chnname || index_th == 0) && item_th.show"
                  :class="{ brdr: item_th.fieldname.indexOf('bflag') > -1 }"
                >
                  <div class="comm_box">
                    <div
                      class="boolean_box fs24"
                      v-if="item_th.fieldname.indexOf('bflag') > -1"
                      @click="showCantennList(all, item_th.fieldname, true)"
                    >
                      {{ all[item_th.fieldname] }}
                      <van-icon name="arrow-down" />
                    </div>
                    <div
                      class="boolean_box"
                      v-else-if="item_th.fieldname != 'yymmdd2'"
                    >
                      <van-checkbox
                        v-model="all['book' + ((((index_th - 1) / 2) | 0) + 1)]"
                        @change="changeAll((((index_th - 1) / 2) | 0) + 1)"
                      >
                      </van-checkbox>
                    </div>
                    <div v-else>
                      批量选择
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <template v-if="dcmsg">
        {{ dcmsg }}
      </template>
      <div class="footerbtn">
        <van-button
          type="info"
          size="small"
          :disabled="!canOrder"
          @click="savePersonInfo"
          >{{ $t('module.submit') }}</van-button
        >   
         <div v-if="empinfo.remark" class="remark">{{empinfo.remark}}</div>    
      </div>
    </div>
    <!-- 饭堂列表 -->
    <van-popup v-model="showCanteenListPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="canteenList"
        :confirm-button-text="$t('module.confirm')"
        :cancel-button-text="$t('module.cancel')"
        @cancel="showCanteenListPicker = false"
        @confirm="onConfirmCanteen"
      />
    </van-popup>
  </div>
</template>

<script>
import { Toast, ImagePreview } from 'vant'
import { parseTime } from '@/utils'
import {
  getSimpleBookMonthInfo,
  saveSimpleBookMonthInfo,
  getFile
} from '@api/wx.js'
import { GetFilterDropDownList } from '@api/wx.js'
export default {
  data() {
    const fromH5 = this.$route.query.fromH5
    const dcmsg = window.dcmsg
    const name = this.$route.query.name
    const userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    const param = this.$route.query.param
    return {
      dcmsg,
      userInfo,
      param, // 从外部过来的参数
      fromH5, // 是否从H5过来的
      name, //传入的标题
      years: [], // 年份数组
      checkedYear: '', // 选中的年份
      CloundEntid: window.CloundEntid || '',
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], // 月份数组
      checkedMonth: '', // 选中的月份
      bookinfo: [], // 员工的点菜信息
      initbookinfo: [], // 初始的员工的点菜信息
      loading: false,
      empid: 0, // 当前登录的empid
      langid: 0, // 当前多语言Id
      empinfo: {},
      tabStyle: 'height:100%', // 表格高度
      lastYYMM: '', // 最后一次搜索的yymm
      thList: [
        {
          fieldname: 'yymmdd2',
          chnname: '',
          show: true
        },
        {
          fieldname: 'book1',
          chnname: '早餐',
          show: true
        },
        {
          fieldname: 'bflag1',
          chnname: '饭堂',
          show: false
        },
        {
          fieldname: 'book2',
          chnname: '中餐',
          show: true
        },
        {
          fieldname: 'bflag2',
          chnname: '饭堂',
          show: false
        },
        {
          fieldname: 'book3',
          chnname: '晚餐',
          show: true
        },
        {
          fieldname: 'bflag3',
          chnname: '饭堂',
          show: false
        },
        {
          fieldname: 'book4',
          chnname: '夜宵',
          show: true
        },
        {
          fieldname: 'bflag4',
          chnname: '饭堂',
          show: false
        },
        {
          fieldname: 'book5',
          chnname: '其他',
          show: true
        },
        {
          fieldname: 'bflag5',
          chnname: '饭堂',
          show: false
        },
        {
          fieldname: 'book6',
          chnname: '测试',
          show: true
        },
        {
          fieldname: 'bflag6',
          chnname: '饭堂',
          show: false
        }
      ],
      all: {
        book1: false,
        book2: false,
        book3: false,
        book4: false,
        book5: false,
        book6: false,
        bflag1: '',
        bflag2: '',
        bflag3: '',
        bflag4: '',
        bflag5: '',
        bflag6: '',
      },
      simple_book_need_ft: false,
      canteenList: [],
      showCanteenListPicker: false,
      isall: false,
      selectRow: {},
      selectFieldname: ''
    }
  },
  computed: {
    // 是否显示提交和编辑
    canOrder() {
      return JSON.stringify(this.initbookinfo) != JSON.stringify(this.bookinfo)
    }
  },
  created() {
    // 获取年
    this.getYearsByDate(new Date())
    // 第一次进来默认当前日期
    this.checkedMonth = new Date().getMonth() + 1
    if (this.fromH5 == true || this.fromH5 == 'true') {
      // console.log('H5过来的');
      this.empid = this.userInfo.empid
      this.langid = localStorage.getItem('langid')
      this.getAllPageDatas('')
    } else {
      // console.log('外部过来的');
      this.empid = this.$route.query.empid
      this.langid = this.$route.query.langid
      this.param = this.$route.query.param
      // 查询页面
      this.getAllPageDatas(this.param)
    }
  },
  mounted() {
    const dateContent = document
      .getElementsByClassName('overflow_div')[0]
      .querySelector('.date_content')
    const dateContent2 = document
      .getElementsByClassName('queryDetails')[0]
      .querySelector('.footer')
    const dateH = dateContent.clientHeight + dateContent2.clientHeight
    this.tabStyle = 'height: calc(100vh - ' + dateH + 'px)'
  },
  methods: {
    // 根据日期获取年份列表
    getYearsByDate(v) {
      if (v) {
        let date = new Date(v)
        let year = date.getFullYear()
        this.years = [year - 1, year, year + 1]
        //
        this.checkedYear = year
      }
    },
    // 不够就补零
    add0(m) {
      return m < 10 ? '0' + m : m
    },
    // 日期时间转换格式
    formatDate(date, rule) {
      if (date) {
        const time = new Date(date)
        const y = time.getFullYear()
        const m = time.getMonth() + 1
        const d = time.getDate()
        const h = time.getHours()
        const mm = time.getMinutes()
        const s = time.getSeconds()
        if (rule == 'yyyy-MM-dd') {
          return y + '-' + this.add0(m) + '-' + this.add0(d)
        } else {
          return (
            y +
            '-' +
            this.add0(m) +
            '-' +
            this.add0(d) +
            ' ' +
            this.add0(h) +
            ':' +
            this.add0(mm)
          )
          // + ':' + this.add0(s)
        }
      } else {
        return ''
      }
    },
    // 返回
    onClickLeft() {
      if (this.$route.query.from == 'home') {
        this.$router.push('/home')
      } else {
        this.$router.push('/personCen')
      }
    },
    // 点击导航右按钮
    onClickRight() {
      if (this.CloundEntid == '139') {
        getFile({
          moduleno: 9959,
          yymm: this.lastYYMM,
          entcode: '',
          empcode: '',
          url:
            window.BASE_URL.toString()
              .split('://')[1]
              .split('/v8api')[0] + '/v8filesvr'
        }).then(res => {
          const images = res.list.map(e => {
            return e.imgurl
          })
          ImagePreview({
            images: images,
            closeable: true
          })
        })
      }
    },
    // 点击选择某个月份
    getOneMonth(v) {
      if (this.checkedMonth == v && false) {
        this.checkedMonth = ''
        this.param = ''
        // 查询页面
        this.getAllPageDatas(this.param)
      } else {
        this.checkedMonth = v
        if (this.checkedYear) {
          this.param = this.checkedYear + '' + this.add0(this.checkedMonth)
          // 查询页面
          this.getAllPageDatas(this.param)
        }
      }
    },
    // 点击选择某个年份
    getOneYear(v) {
      if (this.checkedYear == v && false) {
        this.checkedYear = ''
        this.param = ''
        // 查询页面
        this.getAllPageDatas(this.param)
      } else {
        this.checkedYear = v
        this.param = this.checkedYear + '' + this.add0(this.checkedMonth)
        // 查询页面
        this.getAllPageDatas(this.param)
      }
    },
    // 箭头切换年份
    arrowsYear(v) {
      if (v == 'left') {
        this.years.unshift(this.years[0] - 1)
        this.years.pop()
      } else {
        this.years.push(this.years[2] + 1)
        this.years.shift()
      }
    },
    // 提交按钮
    savePersonInfo() {},
    // 获取页面所有信息
    /*    
          1.psys_get_simplebook_monthinfo 获取简易订餐某个月的订餐信息接口月 
          2.txf_temp_simplebook——data 每日订餐套餐临时数据表
          3.pxf_save_simplebook——monthinfo 保存简易订餐某个月的订餐信息接门
    */
    getAllPageDatas(yymm) {
      this.lastYYMM =
        yymm || this.checkedYear + '' + this.add0(this.checkedMonth)
      getSimpleBookMonthInfo({
        yymm: yymm || this.checkedYear + '' + this.add0(this.checkedMonth),
        empid: this.empid,
        langid: this.langid
      }).then(res => {
        this.all = {
          book1: false,
          book2: false,
          book3: false,
          book4: false,
          book5: false,
          book6: false,
          bflag1: '',
          bflag2: '',
          bflag3: '',
          bflag4: '',
          bflag5: '',
          bflag6: '',
        }
        this.$nextTick(() => {
          res.bookinfo.forEach(e => {
            e.yymmdd2 = parseTime(
              new Date(e.yymmdd.replace(/-/g, '/')),
              '{d}({a})'
            )
          })
          this.bookinfo = res.bookinfo
          this.empinfo = res.empinfo[0]
          this.thList[1].chnname = this.empinfo.bookname1
          this.thList[3].chnname = this.empinfo.bookname2
          this.thList[5].chnname = this.empinfo.bookname3
          this.thList[7].chnname = this.empinfo.bookname4
          this.thList[9].chnname = this.empinfo.bookname5
          this.thList[11].chnname = this.empinfo.bookname6
          this.initbookinfo = JSON.parse(JSON.stringify(res.bookinfo))
          this.simple_book_need_ft = this.empinfo.simple_book_need_ft // 必须选择饭堂
          if (this.simple_book_need_ft) {
            this.GetCanteenList()
            this.thList.forEach((e, i) => {
              if (e.fieldname.indexOf('bflag') > -1) {
                e.show = true && this.thList[i - 1].chnname // 如果该餐别不显示，饭堂也不显示
              }
            })
          }
        })
      })
    },
    // 显示饭堂弹窗
    showCantennList(row, fieldname, isall) {
      this.selectRow = row
      this.selectFieldname = fieldname
      this.isall = isall
      this.showCanteenListPicker = true
    },
    // 饭堂弹窗回调
    onConfirmCanteen(value) {
      if (value == '<清除>') value = ''
      this.selectRow[this.selectFieldname] = value
      if (this.isall) {
        let i = this.selectFieldname.replace('bflag', '')
        this.bookinfo.forEach(e => {
          if (e['can_book' + i]) {
            e[this.selectFieldname] = value
          }
        })
      }
      this.showCanteenListPicker = false
    },
    // 获取饭堂列表
    GetCanteenList() {
      GetFilterDropDownList({
        moduleno: 201,
        username: this.userInfo.username,
        listsql: '@饭堂列表'
      }).then(res => {
        if (res.data.length > 0) {
          this.canteenList = res.data.map(e => {
            return e.dicvalue
          })
          this.canteenList.unshift('<清除>')
        }
      })
    },
    // 保存订餐
    savePersonInfo() {
      let data = {
          yymm: this.empinfo.yymm,
          empid: this.empinfo.empid,
          data: []
        },
        canteenmsg = false,
        cb = '',
        ymd = ''

      this.bookinfo.forEach((e, i) => {
        const e2 = this.initbookinfo[i]
        const obj = {
          yymmdd: e.yymmdd,
          old_book1: e2.book1 ? true : false,
          new_book1: e.book1 ? true : false,
          old_book2: e2.book2 ? true : false,
          new_book2: e.book2 ? true : false,
          old_book3: e2.book3 ? true : false,
          new_book3: e.book3 ? true : false,
          old_book4: e2.book4 ? true : false,
          new_book4: e.book4 ? true : false,
          old_book5: e2.book5 ? true : false,
          new_book5: e.book5 ? true : false,
          old_book6: e2.book6 ? true : false,
          new_book6: e.book6 ? true : false,
          old_bflag1: e2.bflag1 || '',
          new_bflag1: e.bflag1 || '',
          old_bflag2: e2.bflag2 || '',
          new_bflag2: e.bflag2 || '',
          old_bflag3: e2.bflag3 || '',
          new_bflag3: e.bflag3 || '',
          old_bflag4: e2.bflag4 || '',
          new_bflag4: e.bflag4 || '',
          old_bflag5: e2.bflag5 || '',
          new_bflag5: e.bflag5 || '',
          old_bflag6: e2.bflag6 || '',
          new_bflag6: e.bflag6 || '',
        }
        if (e.book1 && e.can_book1 && !e.bflag1) {
          cb = this.thList[1].chnname
          ymd = e.yymmdd
          canteenmsg = true
        } else if (e.book2 && e.can_book2 && !e.bflag2) {
          cb = this.thList[3].chnname
          ymd = e.yymmdd
          canteenmsg = true
        } else if (e.book3 && e.can_book3 && !e.bflag3) {
          cb = this.thList[5].chnname
          ymd = e.yymmdd
          canteenmsg = true
        } else if (e.book4 && e.can_book4 && !e.bflag4) {
          cb = this.thList[7].chnname
          ymd = e.yymmdd
          canteenmsg = true
        } else if (e.book5 && e.can_book5 && !e.bflag5) {
          cb = this.thList[9].chnname
          ymd = e.yymmdd
          canteenmsg = true
        } else if (e.book6 && e.can_book6 && !e.bflag6) {
          cb = this.thList[11].chnname
          ymd = e.yymmdd
          canteenmsg = true
        }
        data.data.push(obj)
      })

      //判断饭堂是否必填
      if (this.simple_book_need_ft) {
        if (canteenmsg) {
          Toast.fail(`订餐失败！请选择${ymd}的${cb}饭堂`)
          return
        }
      }
      // console.log(data, '1111111111')
      saveSimpleBookMonthInfo(data).then(res => {
        if (res.data[0].info) {
          Toast.fail('订餐失败！' + res.data[0].info)
        } else {
          Toast.success('订餐成功！')
        }
        this.getAllPageDatas(data.yymm)
      })
    },
    // 批量选择
    changeAll(i) {
      // console.log(i, this.all['book' + i])
      this.bookinfo.forEach(e => {
        if (e['can_book' + i]) {
          e['book' + i] = this.all['book' + i]
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.fs24 {
  font-size: 24px;
}
.queryDetails {
  height: 100vh;
  overflow: hidden;
  // background: #eceaea;
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
    ::v-deep .van-nav-bar__right {
      .van-nav-bar__text {
        color: #fff;
        font-family: Source Han Sans CN;
      }
    }
  }
  .overflow_div {
    background: #f6f6f6;
    // overflow: auto;
    height: calc(100% - 100px);
    .date_content {
      .year_box {
        display: flex;
        align-items: center;
        padding: 20px 0;
        background: #ffffff;
        .icon_box {
          display: flex;
          align-items: center;
          .van-icon {
            font-size: 40px;
            font-weight: bold;
          }
        }
        .year_btn {
          width: calc((100% - 40px) / 3);
          color: #2a2a2a;
          font-size: 32px;
          font-weight: bold;
          text-align: center;
          background-color: #eff6ff;
          border-radius: 10px;
          .year {
            padding: 10px 0;
          }
        }
        .cao0 {
          margin: 0 20px 0 10px;
        }
        .cao1 {
          margin-right: 20px;
        }
        .cao2 {
          margin-right: 10px;
        }
        .checkd_year {
          color: #ffffff;
          background: #5398ff;
        }
      }
      .month_box {
        display: flex;
        flex-wrap: wrap;
        background: #ffffff;
        padding-bottom: 10px;
        .month_btn {
          width: calc(100% / 6);
          color: #aeaeae;
          font-size: 28px;
          text-align: center;
          .month {
            padding: 10px 0;
            margin: 10px;
          }
          .checkd_Month {
            color: #5095ff;
            background: #ffffff;
            border-radius: 30px;
            border: 1px solid #5095ff;
          }
        }
      }
      .date_box {
        .head_date {
          display: flex;
          align-items: center;
          padding: 20px 0;
          background: #fff;
          .icon_box {
            display: flex;
            align-items: center;
            .van-icon {
              font-size: 40px;
              font-weight: bold;
            }
          }
          .date_box {
            width: calc((100% - 40px) / 7);
            font-size: 28px;
            text-align: center;
            .week {
              margin-bottom: 10px;
            }
            .date {
              display: flex;
              justify-content: center;
              align-items: center;
              .text {
                width: 50px;
                height: 50px;
                line-height: 50px;
                border-radius: 50%;
              }
              .bgtext {
                color: #fff;
                background: #2b8df0;
              }
            }
          }
        }
      }
    }
    .table_content {
      .auto_table {
        height: 100%;
        overflow: auto;
        .table {
          width: 100%;
          border-spacing: 0px;
          tr {
            td:nth-child(1) {
              border-left: 2px solid #dcdfe6;
            }
            th,
            td {
              padding: 15px 10px;
              text-align: center;
              border-bottom: 2px solid #dcdfe6;
              border-right: 2px solid #dcdfe6;
              background: #fff;
              .comm_box {
                .boolean_box {
                  .van-checkbox {
                    z-index: 0;
                    justify-content: center;
                    /deep/.van-checkbox__icon {
                      .van-icon {
                        background: #fff;
                      }
                    }
                    /deep/.van-checkbox__icon--checked {
                      .van-icon {
                        color: #fff !important;
                        background-color: #1989fa !important;
                        border-color: #1989fa !important;
                      }
                    }
                    /deep/.van-checkbox__icon--disabled .van-icon {
                      background-color: rgba(234, 236, 238, 0.39);
                    }
                  }
                }
                .van-checkbox.hasbook {
                  /deep/.van-checkbox__icon {
                    .van-icon {
                      background: #1989fa60;
                      color: #fff !important;
                    }
                  }
                }
                .text_box {
                  font-size: 24px;
                }
              }
            }
            td.disabled {
              background-color: rgb(160, 160, 160);
            }
            td.hol {
              color: rgb(255, 59, 59);
              background-color: rgba(145, 211, 255, 0.411);
            }
          }
          .top {
            position: sticky;
            top: 0;
            font-size: 28px;
            background: #e9f3fd;
            height: 64px;
            z-index: 1;
            th:nth-child(1) {
              border-left: 2px solid #dcdfe6;
            }
            th {
              white-space: nowrap;
              .title {
                white-space: nowrap;
                img {
                  vertical-align: middle;
                }
              }
            }
          }
          .sum {
            height: 64px;
            font-size: 28px;
            position: sticky;
            bottom: 0;
            z-index: 1;

            td {
              background: #ff9100;
            }
          }
        }
      }
    }
    .form_content {
      /deep/.van-collapse {
        height: 100%;
        overflow-y: auto;
        .van-collapse-item {
          margin: 20px;
          .van-collapse-item__title {
            border-radius: 20px 20px 0 0;
            .van-cell__title {
              font-size: 32px;
              font-weight: bold;
              font-family: Source Han Sans CN;
              color: #000;
              .title_bg {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                img {
                  height: 100%;
                }
              }
              .xiba_title {
                display: flex;
                align-items: center;
                position: relative;
                .van-icon {
                  margin-right: 16px;
                }
              }
            }
          }
          .van-collapse-item__wrapper {
            border-radius: 0 0 20px 20px;
            .van-collapse-item__content {
              .peField {
                .van-field {
                  .van-field__label {
                    color: #aeaeae;
                    width: 8em;
                  }
                  .van-field__value {
                    color: #2a2a2a;
                  }
                }
                .not_canedi {
                  .van-field__value {
                    .van-field__body {
                      .van-field__control {
                        color: #2a2a2a;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      .van-hairline--top-bottom::after {
        border: unset;
      }
      .noGroup_box {
        height: 100%;
        overflow-y: auto;
        .noGroup_form {
          padding: 0 50px;
          background-color: #fff;
          .peField {
            .van-field {
              .van-field__label {
                color: #aeaeae;
                width: 8em;
              }
              .van-field__value {
                color: #2a2a2a;
              }
            }
          }
        }
      }
    }
  }
  .footer {
    position: absolute;
    background-color: #ffffff;
    bottom: 0;
    height: 100px;
    width: 100%;
    .footerbtn {
      width: 100%;
      display: flex;
      align-items: center;
      /* text-align: center; */
      justify-content: center;
      flex-direction:column;
      .van-button {
        width: 95%;
        border-radius: 12px;
        .van-button__text {
          font-size: 36px;
          font-family: Source Han Sans SC;
          font-weight: 500;
        }
      }
      .remark{
         font-size: 20px;
         color:red;
      }
    }
  }
  .brdr {
    border-right-color: #000 !important;
  }
}
</style>
